export default function makeSlug(slug: string | undefined | null) {
  if (!slug) {
    return "/";
  }

  return (slug.startsWith("/") ? slug : `/${slug}`).replace("//", "/");
}
